import * as $ from "jquery";
import * as ko from "knockout";
import { Command } from "../command";
import { CommandType } from "../commandType";
import { PopupType } from "../popups/popupType";
import { Application } from "../application";
import { EstimateExportPopupParams } from "../../components/estimate-export-popup/estimate-export-popup";


export class OpenEstimateExportPopupCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.OpenEstimateExportPopup;

    canExecute = ko.computed(() => {
        let estimate = this.app.state.estimate();

        if(!estimate)
            return false;

        return true;
    });
    
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(): JQueryPromise<any> {        
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let estimate = this.app.state.estimate();

        let params = <EstimateExportPopupParams> {
            id: estimate!.id(),
            name: estimate!.name()
        };

        return this.app.popupsManager.show<EstimateExportPopupParams>(PopupType.estimateExport, true, params).done(() => {
            let estimate = this.app.state.estimate();
            if (estimate && estimate.id() == params.id) {
                estimate.name(params.name);
            }
        });
    }

    name = "Export estimate";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/openEstimateExportPopupCommand.ts